declare namespace $ {

	export class $mol_icon_home_city extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=city.view.tree.d.ts.map